import React, { useEffect, useState } from "react";
import Warning from "MODULES/shared/components/Warning/Warning";
import api from "APP_ROOT/api";
import { NO_BIZ } from "MODULES/companies/constants";
import { withFormFields } from "MODULES/shared/decorators";
import { SHIP_TO_COMPANY_ID } from "APP_ROOT/constants";
import { Check } from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import { SHIP_TO_COMPANY_DISABLED } from "MODULES/SalesOrders/constants";

function DoNotDoBusinessShippingWarning({
  ship_to_company_id: { input: { value: shipToCompanyId } },
  ship_to_company_disabled: shipToCompanyDisabled
}) {
  const [shipToCompany, setShipToCompany] = useState(null);

  const setShipToCompanyDisabled = val => {
    if (shipToCompanyDisabled) {
      shipToCompanyDisabled.input.onChange(val);
    }
  };

  useEffect(
    () => {
      if (["", null, undefined].includes(shipToCompanyId)) {
        setShipToCompany(null);
        setShipToCompanyDisabled(false);
      } else {
        api.companies.show(shipToCompanyId).then(({ data }) => {
          setShipToCompany(data);
          if (data.status === NO_BIZ) setShipToCompanyDisabled(true);
        });
      }

      return function cleanup() {};
    },
    [shipToCompanyId]
  );

  if (!shipToCompany) return null;
  if (shipToCompany.status !== NO_BIZ) return null;
  return [
    <Field
      name={SHIP_TO_COMPANY_DISABLED}
      component={Check}
      style={{ display: "none" }}
    />,
    <Warning warningType="danger">
      This Company has been flagged as &apos;Do Not Do Business&apos;. Please
      select another Company or select &apos;Cancel&apos;.
    </Warning>
  ];
}

export default withFormFields(DoNotDoBusinessShippingWarning, [
  SHIP_TO_COMPANY_ID,
  SHIP_TO_COMPANY_DISABLED
]);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/Warnings/DoNotDoBusinessShippingWarning.jsx